export default __webpack_public_path__ + "static/media/logo.ab1b266c.png";